<template>
	<div>
		<div class="frame" ref="room"></div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	props: ['room'],

	data() {
		return {
			api: null,
			domain: '8x8.vc',
			height: '75%',
			options: {
				parentNode: '',
				roomName: this.room,
				// onLoad: function(),
				userInfo: {
					email: '',
					displayName: '',
				},
				configOverwite: {
					disableDeepLinking: true,
					prejoinPageEnabled: false,
					startWithAudioMuted: true,
					startWithVideoMuted: true,
					fileRecordingsEnabled: false,
					remoteVideoMenu: {
						disableKick: true,
					},
					constraints: {
						video: {
							height: {
								ideal: 360,
								max: 480,
								min: 240,
							},
						},
					},
				},
				interfaceConfigOverwrite: {
					SHOW_CHROME_EXTENSION_BANNER: false,
					DISPLAY_WELCOME_PAGE_CONTENT: false,
					LANG_DETECTION: true,
					CLOSE_PAGE_GUEST_HINT: false,
					MOBILE_APP_PROMO: false,
					HIDE_KICK_BUTTON_FOR_GUESTS: true,
					// SHOW_JITSI_WATERMARK: false,
					// SHOW_WATERMARK_FOR_GUESTS: false,
					// SHOW_BRAND_WATERMARK: false,
					TOOLBAR_BUTTONS: [
						'microphone',
						'camera',
						'hangup',
						'closedcaptions',
						'fullscreen',
						'profile',
						'chat',
						'raisehand',
						'videoquality',
						'tileview',
					],
				},
			},
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			name_store: 'common/full_name',
			email_store: 'common/email',
			// clients: 'params/clients',
			// id_user_client_selected: 'common/id_user_client_selected',
		}),
	},

	methods: {
		initialConfig() {
			this.setUserInfo()
			this.addCustomFunctions()
			this.api.executeCommand('setVideoQuality', 360)
			this.api.executeCommand('toggleVideo')
			this.api.executeCommand('toggleAudio')
		},

		setUserInfo() {
			this.api.executeCommand('email', this.email_store)
			this.api.executeCommand('displayName', this.name_store)
		},

		addCustomFunctions() {
			this.api.on('participantJoined', this.newParticipant)

			this.api.on('readyToClose', this.endMeeting)

			this.api.on('readyToClose', () => {
				this.api.dispose()
				this.$emit('hideModalMeeting')
			})
		},

		newParticipant({ displayName }) {
			this.$q.notify({
				message: `${displayName} ${this.$t('joined_the_class')}`,
				type: 'positive',
				icon: 'fal fa-user-plus',
				position: 'left',
			})
		},

		endMeeting() {
			setTimeout(() => {
				if (this.api) {
					this.api.executeCommand('hangup')
					this.api.dispose()
				}
			}, 100)
			setTimeout(() => {
				this.$emit('hideModalClassRoom')
			}, 150)
		},
	},

	beforeDestroy() {
		this.api ? this.api.dispose() : undefined
	},

	async mounted() {
		await this.jitsi()
		this.options.parentNode = this.$refs.room
		this.api = new JitsiMeetExternalAPI(this.domain, this.options)

		this.initialConfig()
	},
}
</script>

<style lang="stylus" scoped>
// .top-mobile-protection
//     position fixed
//     background #0072ce
//     height 350px
//     width 100vw
//     h3
//         text-align center
//         color white
//         padding 3rem 1rem

// .button-mobile-protection
//     background rgba(255, 255, 255, 0.2)
//     position fixed
//     top 400px
//     height 70px
//     width 100vw

// .bottom-mobile-protection
//     position fixed
//     bottom 0
//     background #0072ce
//     height 180px
//     width 100vw

.frame
    height 95vh
    & iframe
        width 100%
        height 70vh
</style>
